module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="dialogPretsRefresh">\r\n    <fieldset class="cw-fieldset">\r\n        <div class="form-group">\r\n            <label class="message_question"></label>\r\n            <div class="custom-control custom-checkbox">\r\n                <input id="neplus" type="checkbox" style="position:relative;bottom:-1px;margin-left:5px;" class="neplus custom-control-input" value="true" />\r\n                <label for="neplus" class="custom-control-label">'+
((__t=(i18n.t('plans.planmed.affichage_prets_ne_plus')))==null?'':__t)+
'</label>\r\n            </div>\r\n    </fieldset>\r\n    <div class="cwDialog-buttons" style="width:100%;text-align:center;justify-content:center;">\r\n        <button type="button" style="margin-right:10px" class="btnConfirm btn btn-primary">'+
((__t=(i18n.t('common:yes')))==null?'':__t)+
'</button>\r\n        <button type="button" style="margin-left:10px" class="btnCancel btn btn-secondary">'+
((__t=(i18n.t('common:no')))==null?'':__t)+
'</button>\r\n    </div>\r\n</div>';
}
return __p;
};
